export default function formatSession(title, animesList, path) {
    return {
        title: title,
        animesList: animesList,
        path: path
    }
}